import React from "react";
import validationSuccessIcon from "@assets/icons/validation-completed.svg";
import validationErrorIcon from "@assets/icons/validation-fail.svg";
import styles from "./UploadValidation.module.css";
import ModalView from "@modals/modalview/ModalView";
function UploadValidation({
  isOpen,
  errorsDetected,
  handleOk,
  onClose,
}: {
  isOpen: boolean;
  errorsDetected: string[];
  handleOk: () => void;
  onClose: () => void;
}) {
  return (
    <ModalView isOpen={isOpen} onClose={onClose}>
      {errorsDetected?.length === 0 ? (
        <div className={styles.validationContainer}>
          <img src={validationSuccessIcon} />
          <h1>Validation Completed!</h1>
          <p className={styles.successMessage}>
            Your data has been added successfully. Please check and verify.
          </p>
          <div className={styles.buttonContainer}>
            <button className={styles.viewButton} onClick={handleOk}>
              Ok
            </button>
          </div>
        </div>
      ) : (
        <div className={styles.validationContainer}>
          <img src={validationErrorIcon} />
          <h1>Validation Failed!</h1>
          <p className={styles.errorMessage}>
            <span>{errorsDetected.length}</span> issues found.
          </p>
          <div className={styles.buttonContainer}>
            <button className={styles.cancelButton} onClick={() => onClose()}>
              Close
            </button>
            <button className={styles.viewButton} onClick={handleOk}>
              View
            </button>
          </div>
        </div>
      )}
    </ModalView>
  );
}

export default UploadValidation;
